import { string, node, shape, bool } from 'prop-types';
export const ALERT_ICONS = {
  error: 'ErrorOutline',
  info: 'CheckCircle',
  warning: 'WarningOutline'
};
export const DEFAULT_ALERT_CONTENT = {
  type: '',
  message: ''
};
export const PROPTYPES = {
  title: string,
  children: node,
  alertContent: shape({
    message: string,
    type: string
  }),
  withBorder: bool
};
export const DEFAULT_PROPS = {
  title: '',
  children: null,
  alertContent: DEFAULT_ALERT_CONTENT,
  withBorder: false
};